import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTimes } from "@fortawesome/pro-light-svg-icons";
import { useDeepEffect } from "../../abstracts";
import { get } from "lodash";

const UploadComponentCustodianImage = (props) => {
  const {
    setFieldValue,
    label,
    name,
    values,
    clearUploadFile,
    setFileUploadRequired,
    setNewFile,
    clearField,
    setClearField,
    setShowFileName,
  } = props;
  const [myFiles, setMyFiles] = useState(get(values, "uploadSourceFile", []));

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (myFiles.length === 0) {
        setMyFiles([...myFiles, ...acceptedFiles]);
        setFieldValue(name, acceptedFiles);
        if (setNewFile) {
          setNewFile(name, acceptedFiles);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [myFiles]
  );
  useDeepEffect(() => {
    if (clearField) {
      setMyFiles([]);
      setClearField(false);
      setShowFileName(true);
    }
  }, [clearField]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: ".jpeg, .png, .jpg",
  });

  const removeFile = (file) => () => {
    const newFiles = [...myFiles];
    if (setFileUploadRequired) {
      setFileUploadRequired("");
    }
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
    if (clearUploadFile) {
      clearUploadFile();
    }
    if (setNewFile) {
      setNewFile([]);
      setFieldValue(name, undefined);
      setShowFileName(true);
    }
  };

  const files = myFiles.map((file) => (
    <div className="d-flex" style={{ justifyContent: "flex-start" }}>
      <span
        style={{
          textOverflow: "ellipsis",
        }}
      >
        {file.path}
      </span>
      <span
        className="ml-4"
        style={{ cursor: "pointer" }}
        onClick={removeFile(file)}
      >
        <FontAwesomeIcon
          icon={faTimes}
          color={"#ff0000"}
          onClick={() => setFieldValue(name, undefined)}
        />
      </span>
    </div>
  ));

  return (
    <div>
      {}
      <label className="label-text ml-0">{label}</label>
      <div {...getRootProps({ className: "dropzone" })}>
        <input name={name} {...getInputProps()} disabled={myFiles.length} />
        {isDragActive ? (
          <div className="upload-docs">
            <FontAwesomeIcon icon={faUpload} />
            <p> Drag & drop here</p>
            <p> or</p>
            <p className="link-text"> Browse file</p>
          </div>
        ) : (
          <div className="upload-docs">
            <FontAwesomeIcon icon={faUpload} />
            <p> Drag & drop here</p>
            <p> or</p>
            <p className="link-text"> Browse file</p>
          </div>
        )}
      </div>
      <span className="file-type ml-0 d-flex" style={{ width: "343px" }}>
        <div> Accepted File Type : jpeg, png, jpg </div>{" "}
        <div className="ml-auto">Max File Size : 1MB</div>
      </span>
      {files}
    </div>
  );
};

export default UploadComponentCustodianImage;
